import { render, staticRenderFns } from "./chipsCancel.vue?vue&type=template&id=2baf6a9a&scoped=true"
import script from "./chipsCancel.vue?vue&type=script&lang=js"
export * from "./chipsCancel.vue?vue&type=script&lang=js"
import style0 from "./chipsCancel.vue?vue&type=style&index=0&id=2baf6a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf6a9a",
  null
  
)

export default component.exports